export const isReadonlyArray = <T>(arg: ReadonlyArray<T> | T): arg is ReadonlyArray<T> => {
  return Array.isArray(arg)
}
